import { Button, Input } from '@iwoca/orion';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './AddPhoneNumberForm.module.css';
import {
    ADD_PHONE_NUMBER,
    CHANGE_PHONE_NUMBER,
    TOGGLE_ADD_PHONE_NUMBER
} from '../../IdCheckVerificationModal.actions';
import { TDeserialisedPerson } from '../../IdCheckVerificationModal.types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeNumber: (personUID: string, phoneNumber: string) =>
        dispatch({ type: CHANGE_PHONE_NUMBER, personUID, phoneNumber }),
    addPhoneNumber: (person: TDeserialisedPerson) =>
        dispatch({ type: ADD_PHONE_NUMBER, person }),
    toggleAddPhoneNumber: (personUID: string) =>
        dispatch({ type: TOGGLE_ADD_PHONE_NUMBER, personUID })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const AddPhoneNumberForm = ({
    person,
    changeNumber,
    toggleAddPhoneNumber,
    addPhoneNumber
}: { person: TDeserialisedPerson } & PropsFromRedux) => {
    const intl = useIntl();

    const submitNumber = () => {
        if (!person.newPhoneNumber || person.addPhoneNumberPending) return;
        addPhoneNumber(person);
    };

    return (
        <>
            {person.error && (
                <span className={styles.error}>
                    <FormattedMessage
                        id="_.modal.id_check_verification.error.enter_valid_number"
                        defaultMessage="Please enter a valid mobile number"
                    />
                </span>
            )}
            <form
                className={styles.AddPhoneNumberForm}
                onSubmit={(event) => {
                    event.preventDefault();
                    submitNumber();
                }}
            >
                <Input
                    data-testid="phoneNumberInput"
                    wrapperClassName={styles.phoneNumberInput}
                    className="fs-exclude"
                    placeholder={intl.formatMessage({
                        id: '_.modal.id_check_verification.your_phone_number',
                        defaultMessage: 'Your mobile'
                    })}
                    type="tel"
                    autoComplete="tel"
                    onChange={(event) =>
                        changeNumber(person.uid, event.target.value)
                    }
                />
                <Button
                    type="submit"
                    disabled={
                        !person.newPhoneNumber || person.addPhoneNumberPending
                    }
                    loading={person.addPhoneNumberPending}
                >
                    <FormattedMessage
                        id="_.modal.id_check_verification.save"
                        defaultMessage="Save"
                    />
                </Button>
                <Button
                    type="button"
                    variant="secondary"
                    onClick={() => toggleAddPhoneNumber(person.uid)}
                >
                    <FormattedMessage
                        id="_.modal.id_check_verification.cancel"
                        defaultMessage="Cancel"
                    />
                </Button>
            </form>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(AddPhoneNumberForm);
